{
  "title": "Add Client to a Household",
  "relationship": "Relationship",
  "relationshipTo": "Relationship to primary member {{whom}}",
  "alreadyMemberOf": "Client is already member of",
  "thisHousehold": "this household",
  "anotherHousehold": "another household",
  "memberSummary": "Household Member Summary",
  "pleaseReview": "Please review your information to ensure it’s correct.",
  "name": "Client Name",
  "householdName": "Household Name",
  "addToHousehold": "Add to Household",
  "added": "{{memberName}} has been added to {{householdName}} household",
  "failed": "Adding a new member failed.",
  "done": "Done",
  "save": "Save",
  "continue": "Continue",
  "accessType": "Permissions",
  "householdUpdated": "Household has been updated for the client",
  "clientAddedToHousehold": "Client has been added to household",
  "alreadyMemberOfHousehold": "Client is already member of {{householdName}}",
  "back": "Back"
}
